export const API_BASE = String(process.env.REACT_APP_API_BASE || "")
  .trim()
  .replace(/\/+$/, "")
  .replace(/\/api$/i, "");

async function request(path, options = {}) {
  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = { ...(options.headers || {}) };
  if (!isFormData && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...options,
    headers,
  });

  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const data = isJson ? await res.json().catch(() => ({})) : await res.text();

  if (!res.ok) {
    const message =
      (isJson && data && data.error) ||
      (typeof data === "string" ? data : "Request failed");
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  requestLink: (email, turnstileToken) =>
    request("/api/auth/request-link", {
      method: "POST",
      body: JSON.stringify({ email, turnstileToken }),
    }),

  verify: (token, remember) =>
    request("/api/auth/verify", {
      method: "POST",
      body: JSON.stringify({ token, remember }),
    }),

  logout: () => request("/api/auth/logout", { method: "POST", body: "{}" }),

  me: () => request("/api/auth/me"),

  resources: () => request("/api/members/resources"),

  adminMembers: () => request("/api/admin/members"),

  adminAddMember: (email, first_name) =>
    request("/api/admin/members", {
      method: "POST",
      body: JSON.stringify({ email, first_name }),
    }),

  adminBulkMembers: (members) =>
    request("/api/admin/members/bulk", {
      method: "POST",
      body: JSON.stringify({ members }),
    }),

  adminPatchMember: (id, patch) =>
    request(`/api/admin/members/${id}`, {
      method: "PATCH",
      body: JSON.stringify(patch),
    }),

  adminDeleteMember: (id) =>
    request(`/api/admin/members/${id}`, { method: "DELETE" }),

  adminAccessRequests: (includeBlocked = false) =>
    request(
      `/api/admin/access-requests${includeBlocked ? "?include_blocked=1" : ""}`
    ),

  adminEnroll: (id, first_name) =>
    request(`/api/admin/access-requests/${id}/enroll`, {
      method: "POST",
      body: JSON.stringify({ first_name }),
    }),

  adminBlock: (id) =>
    request(`/api/admin/access-requests/${id}/block`, {
      method: "POST",
      body: "{}",
    }),

  adminAuditLogs: (params = {}) => {
    const q = new URLSearchParams();
    if (params.limit) q.set("limit", params.limit);
    if (params.offset) q.set("offset", params.offset);
    if (params.event_type) q.set("event_type", params.event_type);
    if (params.email) q.set("email", params.email);
    const qs = q.toString();
    return request(`/api/admin/audit-logs${qs ? `?${qs}` : ""}`);
  },

  adminEmailUsage: () => request("/api/admin/email-usage"),

  forSaleList: (category, firearmType, page, opts = {}) => {
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    if (firearmType) q.set("firearm_type", firearmType);
    if (page) q.set("page", String(page));
    if (opts.hidden) q.set("hidden", "1");
    const qs = q.toString();
    return request(`/api/for-sale${qs ? `?${qs}` : ""}`);
  },

  forSaleGet: (id) => request(`/api/for-sale/${id}`),

  forSaleCreate: (formData) =>
    request("/api/for-sale", {
      method: "POST",
      body: formData,
    }),

  forSalePatch: (id, patch) =>
    request(`/api/for-sale/${id}`, {
      method: "PATCH",
      body: JSON.stringify(patch),
    }),

  forSaleReplacePhotos: (id, formData) =>
    request(`/api/for-sale/${id}/photos`, {
      method: "PUT",
      body: formData,
    }),

  forSaleDelete: (id) =>
    request(`/api/for-sale/${id}`, { method: "DELETE" }),

  forSaleSetSold: (id, sold) =>
    request(`/api/for-sale/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ sold }),
    }),

  forSaleSetHidden: (id, hidden) =>
    request(`/api/for-sale/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ hidden }),
    }),

  forSaleContact: (id, message, turnstileToken) =>
    request(`/api/for-sale/${id}/contact`, {
      method: "POST",
      body: JSON.stringify({ message, turnstileToken }),
    }),
};

export function contactApiUrl() {
  return `${API_BASE}/api/contact`;
}
